import { createFieldSetter } from 'features/libra/stepComponents/niiReport/createFieldSetter'
import { EditableNumber } from 'features/libra/stepComponents/niiReport/NiiFieldComponents'
import { useNiiReportData } from 'features/libra/stepComponents/niiReport/NiiReportDataContext'
import {
  DescriptionItem,
  OptionalDescriptions,
} from 'features/libra/stepComponents/niiReport/OptionalDescriptions'
import React, { FC, memo, useMemo } from 'react'

import { StyledCard } from './cardsStyles'

const RawNiiCoverageCard: FC = () => {
  const { niiData, setNiiData, isLoading } = useNiiReportData()
  const coverage = niiData?.coverage
  const [setCoveragePercentage, setCoverageArea] = useMemo(() => {
    const setCoverage = createFieldSetter('coverage', setNiiData)
    return [
      createFieldSetter('coverage_percentage', setCoverage),
      createFieldSetter('coverage_area', setCoverage),
    ]
  }, [setNiiData])

  const items = useMemo<ReadonlyArray<DescriptionItem>>(
    () => [
      [
        'Coverage Percentage',
        <EditableNumber
          key='coveragePercentage'
          value={coverage?.coverage_percentage}
          onChange={setCoveragePercentage}
          units='%'
          min={0}
          max={100}
          step={1}
        />,
      ],
      [
        'Coverage Area',
        <EditableNumber
          key='coverageArea'
          value={coverage?.coverage_area}
          onChange={setCoverageArea}
          units='m²'
          min={0}
          step={1}
        />,
      ],
    ],
    [
      coverage?.coverage_area,
      coverage?.coverage_percentage,
      setCoverageArea,
      setCoveragePercentage,
    ]
  )
  return (
    <StyledCard title='Coverage'>
      <OptionalDescriptions items={items} isLoading={isLoading} />
    </StyledCard>
  )
}

export const NiiCoverageCard = memo(RawNiiCoverageCard)
